module.exports = __webpack_public_path__ + "img/scuba-diving.76eb5e47.svg";